import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import LinkToLogin from "../LinkToLogin";

export default function PasswordSuccess(props) {
    const {t} = useTranslation();

    return (
        <div className={"wrapper__login m--0a d--flex jc--c"}>
            <div className="wrapper__login-bg"></div>
            <div className="w--40 sm:w--100 as--c">
                <h1 className={"heading--l text--center mb--3"}>{t('auth_reset_success')}</h1>
                <div className="d--flex jc--c mt--3">
                    <LinkToLogin/>
                </div>

            </div>
        </div>
    )
}